module.exports = __webpack_public_path__ + "img/logo.17640528.png";